var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pull"}},[(this.$store.state.loggedIn)?_c('div',{attrs:{"id":"hide"}},[_c('cellars')],1):_c('div',{attrs:{"id":"hide"}},[_vm._v("This is One Beer Left")])])}
var staticRenderFns = []

export { render, staticRenderFns }